module.exports = __webpack_public_path__ + "assets/img/busy_7.9aad3b29.png";